import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('../store/address.js'), 'address.js')
  resolveStoreModules(require('../store/carriers.js'), 'carriers.js')
  resolveStoreModules(require('../store/cart.js'), 'cart.js')
  resolveStoreModules(require('../store/checkout.js'), 'checkout.js')
  resolveStoreModules(require('../store/favorite.js'), 'favorite.js')
  resolveStoreModules(require('../store/password.js'), 'password.js')
  resolveStoreModules(require('../store/products_visited.js'), 'products_visited.js')
  resolveStoreModules(require('../store/todos.js'), 'todos.js')
  resolveStoreModules(require('../store/user/index.js'), 'user/index.js')
  resolveStoreModules(require('../store/product/index.js'), 'product/index.js')
  resolveStoreModules(require('../store/newCategory/index.js'), 'newCategory/index.js')
  resolveStoreModules(require('../store/categories/index.js'), 'categories/index.js')
  resolveStoreModules(require('../store/blogs/index.js'), 'blogs/index.js')
  resolveStoreModules(require('../store/account/googlewallet.js'), 'account/googlewallet.js')
  resolveStoreModules(require('../store/account/orders.js'), 'account/orders.js')
  resolveStoreModules(require('../store/common/countries.js'), 'common/countries.js')
  resolveStoreModules(require('../store/popups/addToCartMobile.js'), 'popups/addToCartMobile.js')
  resolveStoreModules(require('../store/popups/newsletter.js'), 'popups/newsletter.js')
  resolveStoreModules(require('../store/shared/menu.js'), 'shared/menu.js')
  resolveStoreModules(require('../store/shared/topBanner.js'), 'shared/topBanner.js')
  resolveStoreModules(require('../store/shared/wind.js'), 'shared/wind.js')
  resolveStoreModules(require('../store/shop/categories.js'), 'shop/categories.js')
  resolveStoreModules(require('../store/shop/codepromo.js'), 'shop/codepromo.js')
  resolveStoreModules(require('../store/shop/loyalty.js'), 'shop/loyalty.js')
  resolveStoreModules(require('../store/shop/menu.js'), 'shop/menu.js')
  resolveStoreModules(require('../store/shop/returns.js'), 'shop/returns.js')
  resolveStoreModules(require('../store/shop/settings.js'), 'shop/settings.js')
  resolveStoreModules(require('../store/user/customerService.js'), 'user/customerService.js')
  resolveStoreModules(require('../store/user/guest.js'), 'user/guest.js')
  resolveStoreModules(require('../store/user/orders.js'), 'user/orders.js')
  resolveStoreModules(require('../store/user/address/index.js'), 'user/address/index.js')
  resolveStoreModules(require('../store/shop/localisation/index.js'), 'shop/localisation/index.js')
  resolveStoreModules(require('../store/shop/payment/bankCard.js'), 'shop/payment/bankCard.js')
  resolveStoreModules(require('../store/shop/payment/paymentMethods.js'), 'shop/payment/paymentMethods.js')
  resolveStoreModules(require('../store/shop/tunnel/address.js'), 'shop/tunnel/address.js')
  resolveStoreModules(require('../store/shop/tunnel/order.js'), 'shop/tunnel/order.js')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const propertyStoreModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(propertyStoreModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
